// extracted by mini-css-extract-plugin
module.exports = {"globalContextTranslateMenu":"GlobalContextMenu_globalContextTranslateMenu__1loZT","change":"GlobalContextMenu_change__2e3bl"};